import React, { useEffect } from "react";
import { Box } from "@mui/material";
import ContentBox from "@/src/components/Box/ContentBox/ContentBox";
import FormSubmit from "@/src/components/Form/Common/FormSubmit/FormSubmit";
import Grid from "@mui/material/Grid";
import ContractData from "./ContractData";
import ContractualPartnerData from "./ContractualPartnerData";
import InsuranceData from "./InsuranceData";
import { useLocation } from "react-router";
import SummaryContractDetails from "./SummaryContractDetails";
import DebtCollectionAgencyData from "./DebtCollectionAgencyData";
import { getCaseLink } from "@/src/services/productService";
import { useForm } from "@/src/provider/Form/FormProvider";
import Typography from "@mui/material/Typography";
import EmailVerificationModal from "@/src/components/FormInfoModal/EmailVerificationModal";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import PersonalAffection from "./PersonalAffection";
import { isFlexServiceProduct } from "@/src/services/advocardService";
import SummaryDetailsItem from "@/src/components/Form/Common/SummaryDetailsItem/SummaryDetailsItem";
import summaryStyle from "./summaryStyle";

type SummaryProps = {
  product: AbstractCase;
  submitProps: Record<string, any>;
};

const Summary = ({ product, submitProps }: SummaryProps) => {
  const location = useLocation();
  const stateField = location.state?.field;
  const { values, handleSubmit } = useForm();

  useEffect(() => {
    const el = document.getElementById(stateField);
    el && el.scrollIntoView();
  }, [stateField]);

  return (
    <ContentBox>
      <Typography variant={"h5"}>Ihre Angaben</Typography>
      <Grid container>
        <Box id={"contractData"} />
        <ContractData caseData={product} />
        {product.caseCategory !== "advisory" && (
          <>
            <SummaryContractDetails caseData={product} />
            {product.name !== "dataLeakContract" && (
              <>
                <Box id={"contractualPartnerData"} />
                <ContractualPartnerData title={"Angaben zum Vertragspartner"} formData={values} />
              </>
            )}
          </>
        )}
        {product.caseCategory === "defendClaim" && product.defenseProcessStatus === "debtCollection" && (
          <>
            <Box id={"debtCollectionAgencyData"} />
            <DebtCollectionAgencyData title={"Angaben zum Inkassobüro"} formData={values} />
          </>
        )}
        {product.name !== "dataLeakContract" && (
          <>
            <Box id={"concernSummary"} />
            <Grid sx={summaryStyle.subHeadline} size={12}>
              <Typography variant={"h6"}>Zusammenfassung Ihres Anliegens</Typography>
            </Grid>
            <SummaryDetailsItem fieldPath={"finalClientDescriptionAndObjectives"} caseData={product} />
          </>
        )}
        {product.name === "dataLeakContract" && <PersonalAffection title={"Persönliche Betroffenheit"} product={product} />}
        <Box id={"insuranceData"} />
        {!isFlexServiceProduct(product) && <InsuranceData title={"Versicherung"} formData={values} product={product} />}
      </Grid>
      <form onSubmit={handleSubmit}>
        <FormSubmit
          sx={{ marginTop: "1rem" }}
          {...submitProps}
          hideBackButton={false}
          backLink={getCaseLink(product) + "/antrag/vertrag"}
          backText={"Alles bearbeiten"}
          nextText={"Angaben speichern"}
        />
      </form>
      <EmailVerificationModal />
    </ContentBox>
  );
};

export default Summary;
